import { CommonModule } from "@angular/common";
import { LOCALE_ID, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BtnFilterCheckboxComponent } from "./botoes/btn-filter-checkbox/btn-filter-checkbox.component";
import { DialogConfirmComponent } from "./dialog-confirm/dialog-confirm.component";
import { MaterialModule } from "./material.module";

import {
  RECAPTCHA_LANGUAGE,
  RECAPTCHA_SETTINGS,
  RecaptchaFormsModule,
  RecaptchaModule,
  RecaptchaSettings,
} from "ng-recaptcha";
// import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

import { CardBoxComponent } from "../components/card-box/card-box.component";
import { WizardComponent } from "./wizard/wizard.component";
// import { TextMaskModule } from "angular2-text-mask";
import { AutocompleteLibModule } from "angular-ng-autocomplete";
import { NgxMaskModule } from 'ngx-mask';
import { SwiperModule } from "swiper/angular";
import { BtnMatDialogCloseComponent } from "./botoes/btn-mat-dialog-close/btn-mat-dialog-close.component";
import { DeclarationPdfComponent } from './componentes/declaration-pdf/declaration-pdf.component';
import { modalRegisterBankModule } from "./componentes/modal-register-bank/modal-register-bank.module";
import { UploadDocumentsComponent } from './componentes/upload-documents/upload-documents.component';


// const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
//   direction: 'horizontal',
//   slidesPerView: 'auto'
// };

@NgModule({
  declarations: [
    WizardComponent,
    CardBoxComponent,
    DialogConfirmComponent,
    BtnFilterCheckboxComponent,
    BtnMatDialogCloseComponent,
    UploadDocumentsComponent,
    DeclarationPdfComponent,
    // BreadcrumbVbModule,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    MaterialModule, // Contém modulos ./material.module.ts
    // TextMaskModule,
    AutocompleteLibModule,
    // SweetAlert2Module.forRoot(),
    RecaptchaModule,
    RecaptchaFormsModule,
    SwiperModule,
    modalRegisterBankModule,
    NgxMaskModule.forRoot()
  ],
  exports: [
    BtnFilterCheckboxComponent,
    MaterialModule,
    RouterModule,
    WizardComponent,
    DialogConfirmComponent,
    CardBoxComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UploadDocumentsComponent,
    // TextMaskModule,
    AutocompleteLibModule,
    // SweetAlert2Module,
    RecaptchaModule,
    RecaptchaFormsModule,
    SwiperModule,
    BtnMatDialogCloseComponent,
    modalRegisterBankModule,
    DeclarationPdfComponent,
    // BreadcrumbVbModule,
  ],
  providers: [
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
      } as RecaptchaSettings,
    },
    { provide: RECAPTCHA_LANGUAGE, useValue: "pt_br" },
    { provide: LOCALE_ID, useValue: "pt-BR" },
    // { provide: SWIPER_CONFIG,  useValue: DEFAULT_SWIPER_CONFIG },
  ],
})
export class SharedModule {}
